import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom"; // Import navigation hook

function Add() {
    const navigate = useNavigate();

    // Redirect to Inventory Page
    const handleAddProduct = () => {
        navigate("/inventory"); // Update this route if your inventory page has a different path
    };

    return (
        <Section>
            <div>
                <button onClick={handleAddProduct}>Add Product</button>
            </div>
        </Section>
    );
}

export default Add;
const Section = styled.section`
    display: flex;
    gap: 1rem;
    align-items: center;
    div {
        button {
            border-radius: 0.5rem;
            padding: 1rem 6.6rem;
            border: none;
            cursor: pointer;
            background-color: black;
            color: white;
            font-weight: bold;

            &:hover {
                background-color: #668dff;
            }
        }
    }
`;